module.exports = __webpack_public_path__ + "img/08.a27b2940.png";